import React, { memo, useState, useContext } from 'react';
import { Accordion, AccordionBody, AccordionHeader, AccordionItem } from 'reactstrap';
import "../cardtab.css";
import { imageBaseUrl } from '../../../../utils/constants';
import { ApiDispatchContext } from '../../../../context/ApiContext';
import { getUrlParameter } from '../../../../constants/commonFunction';

const AssignedInvestigators = memo((props) => {
    const [open, setOpen] = useState('0');
    let casid = Number(getUrlParameter('case'));
    const api = useContext(ApiDispatchContext);
    const toggle = (id) => {
        if (open === id) {
            setOpen('0');
        } else {
            setOpen(id);
        }
    };


    const withdrawInvestigatorHandler = (caseId, investigatorId) => {
        toggle()
        if (props ?.onWithdrawInvestigatorHandler) {
            return props.onWithdrawInvestigatorHandler(caseId, investigatorId)
        }
    }

    return (
        <div className='assignedInvestigators'>
            <Accordion open={open} toggle={toggle}>
                {props ?.assigned_investigators ?.investigators &&
                    props.assigned_investigators.investigators.length > 0 &&
                    props.assigned_investigators.investigators.map((item, outerIndex) => {
                        // Ensure item is an array with actual label/value pairs
                        const hasValidData = Array.isArray(item) && item.some(i => i.label && i.value);
                        if (!hasValidData) return null;
                        const serialNo = outerIndex + 1;
                        return (
                            <AccordionItem key={outerIndex}>
                                <AccordionHeader targetId={`accordion-${outerIndex}`}>
                                    Assigned Investigator - {serialNo}
                                </AccordionHeader>
                                <AccordionBody accordionId={`accordion-${outerIndex}`}>
                                    <div className="investigatorDetail_container row">
                                        {item.map((val, idx) =>
                                            val.label && val.value ? (
                                                <div className="col-4" key={idx}>
                                                    <div className="label">{val.label}:</div>
                                                    <div className="value" title={val.value}>{val.value}</div>
                                                </div>
                                            ) : null
                                        )}
                                    </div>
                                    <button
                                        className="withdrawButton"
                                        onClick={() => {
                                            const idObj = item.find((val) => val.investigator_id);
                                            if (idObj ?.investigator_id) {
                                                withdrawInvestigatorHandler(casid, idObj.investigator_id);
                                            }
                                        }}
                                    > Withdraw</button>
                                </AccordionBody>
                            </AccordionItem>
                        );
                    })}
            </Accordion>
        </div>
    )
})

AssignedInvestigators.propTypes = {}

export default AssignedInvestigators